<template>
  <kims-layout>
    <div>
      <div class="row">
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body">
              <div class="d-flex">
                <div class="me-3">
                  <img
                      :src="avatar.avatar"
                      alt=""
                      class="avatar-sm rounded-circle img-thumbnail"
                  />
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="text-muted">
                        <h5 class="mb-1">{{ avatar.firstName }} {{avatar.lastName}}</h5>
                        <p class="mb-0">{{ avatar.email }}</p>
                      </div>
                    </div>

                    <router-link to="/profile">
                      <b-button variant="dark" size="sm" class="py-1 text-white">
                        <i class="bx bxs-cog align-middle me-1"></i>
                        Profile
                      </b-button>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        <b-tabs pills justified content-class="p-3 text-muted mx-4">
          <b-tab active class="border-0" v-if="isUserStaff()">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">Sales Performance</span>
            </template>
            <SalesPerformance/>
          </b-tab>
          <b-tab class="border-0" v-if="isUserStaff()">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">Payments</span>
            </template>
            <div>
              <PaymentsCollected/>
              <OrdersPaymentDue/>
            </div>
          </b-tab>
          <b-tab class="border-0" v-if="isUserStaff()">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">Orders</span>
            </template>
            <div class="row">
              <div class="col-xl-12">
                <OrdersForDelivery/>
              </div>
              <div class="col-xl-12">
                <OrdersForCollection/>
              </div>
              <div class="col-xl-12">
                <SampleOrdersForDelivery/>
              </div>
              <div class="col-xl-12">
                <SampleOrdersForCollection/>
              </div>
            </div>
          </b-tab>
          <b-tab class="border-0" v-if="isUserStaff()">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">User Activity</span>
            </template>
            <div class="col-5">
              <UserActivity />
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </kims-layout>
</template>

<script>
import KimsLayout from "@/router/layouts/kims-layout";
import '@sum.cumo/vue-datepicker/dist/Datepicker.css'
import SalesPerformance from "@/components/dashboard/SalesPerformance";
import PaymentsCollected from "@/components/dashboard/PaymentsCollected";
import OrdersForDelivery from "@/components/dashboard/OrdersForDelivery";
import OrdersPaymentDue from "@/components/dashboard/OrdersPaymentDue";
import OrdersForCollection from "@/components/dashboard/OrdersForCollection";
import UserActivity from "@/components/dashboard/UserActivity";
import SampleOrdersForDelivery from "@/components/dashboard/SampleOrdersForDelivery";
import SampleOrdersForCollection from "@/components/dashboard/SampleOrdersForCollection";

export default {
  name: "dashboard",
  components: {
    SampleOrdersForCollection,
    SampleOrdersForDelivery,
    UserActivity, OrdersForCollection, OrdersForDelivery,
    OrdersPaymentDue, PaymentsCollected,
    SalesPerformance,
    KimsLayout},
  data(){
    return {
    }
  },
  computed: {
    avatar(){
      return JSON.parse(localStorage.getItem('activeUser'))
    },
  },
}
</script>

<style scoped>

</style>
